import { CreateRequestBlock } from './CreateRequestBlock'
import { IntroductionBlock } from './IntroductionBlock'

export const SearchIntroduction = () => {
  return (
    <>
      <IntroductionBlock />
      <CreateRequestBlock />
    </>
  )
}
